import { storageGet } from 'src/utils';
import { LayoutActionTypes } from 'src/store/constants';

const initialLayoutTheme = () => {
  const item = storageGet('theme');
  return item ? item : 'light';
};

const initialState: LayoutState = {
  theme: initialLayoutTheme()
};

const layoutReducer = (
  state = initialState,
  { type, payload }: LayoutAction
) => {
  switch (type) {
    case LayoutActionTypes.HANDLE_THEME:
      return { ...state, theme: payload };
    default:
      return state;
  }
};

export default layoutReducer;
